import Axios from "axios";
import { createExcelImportService } from "@/services/base/ExcelImportDataService";

class FuncionarioPreContratracaoDataService {
  getAll() {
    return Axios.get("funcionarioPreContratracao");
  }

  getPage(params) {
    return Axios.get("funcionarioPreContratracao/page", { params });
  }

  create(params) {
    return Axios.post("funcionarioPreContratracao", params);
  }

  update(params) {
    return Axios.put(`funcionarioPreContratracao/${params.id}`, params);
  }

  find(id) {
    return Axios.get(`funcionarioPreContratracao/${id}`);
  }

  delete(id) {
    return Axios.delete(`funcionarioPreContratracao/${id}`);
  }

  aprovar(params) {
    return Axios.put(`funcionarioPreContratracao/aprovar/${params.id}`, params);
  }

  getByKey(key) {
    return Axios.get(`funcionarioPreContratracao/key/${key}`);
  }

  fillByKey(key, payload, files = []) {
    const formData = new FormData();
    formData.append(
      "data",
      new Blob([JSON.stringify(payload)], { type: "application/json" })
    );

    (files || []).forEach((file) => {
      if (file) formData.append("files", file);
    });

    return Axios.post(`funcionarioPreContratracao/key/${key}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  export(params) {
    return Axios.put("funcionarioPreContratracao/export", params);
  }

  exportExcel(params, config) {
    return Axios.put("funcionarioPreContratracao/exportExcel", params, config);
  }

  reativar(params) {
    return Axios.put("funcionarioPreContratracao/reativar/" + params.id);
  }

  changeTenant(id, idTenant) {
    return Axios.put(
      `funcionarioPreContratracao/changeTenant/${id}/${idTenant}`
    );
  }

  getModelosDocumentacaoAcessoria() {
    return Axios.get(
      "funcionarioPreContratracao/documentacaoAcessoria/modelos"
    );
  }

  printDocumentacaoAcessoria(id, payload) {
    return Axios.put(
      `funcionarioPreContratracao/${id}/documentacaoAcessoria/print`,
      payload,
      { responseType: "blob" }
    );
  }

  getFilter(params) {
    return Axios.post("funcionarioPreContratracao/filter", params);
  }
}

export default Object.assign(
  new FuncionarioPreContratracaoDataService(),
  createExcelImportService("funcionarioPreContratracao")
);
